import Chip from "@mui/material/Chip";
import DeleteIcon from "@mui/icons-material/Delete";
import Grid from "@mui/material/Grid";
import { countries } from "utils";

const STYLES = {
  chip: {
    width: "100%",
    justifyContent: "space-between",
    px: "1rem",
  },
};

const CountryList = ({ countriesList, handleDelete }) => {
  // 🔹 map code -> label, sort by label, then keep code
  const sortedCountries = countriesList
    ?.map(code => {
      const label = countries.find(c => c.code === code)?.label || code;
      return { code, label };
    })
    .sort((a, b) =>
      a.label.localeCompare(b.label, undefined, { sensitivity: "base" })
    );

  return (
    <Grid container spacing={2}>
      {sortedCountries &&
        sortedCountries.map((item, index) => (
          <Grid item key={index}>
            <Chip
              label={item.label}
              onDelete={() => handleDelete(item.code, item.label)}
              deleteIcon={<DeleteIcon />}
              variant="outlined"
              sx={STYLES.chip}
            />
          </Grid>
        ))}
    </Grid>
  );
};

export default CountryList;
